/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RttrStandingEntry } from './RttrStandingEntry';
import {
    RttrStandingEntryFromJSON,
    RttrStandingEntryFromJSONTyped,
    RttrStandingEntryToJSON,
    RttrStandingEntryToJSONTyped,
} from './RttrStandingEntry';

/**
 * 
 * @export
 * @interface RttrStandingsResponse
 */
export interface RttrStandingsResponse {
    /**
     * MongoDB ObjectId of the challenge, used to join the WebSocket room for live updates.
     * @type {string}
     * @memberof RttrStandingsResponse
     */
    challengeId: string;
    /**
     * 
     * @type {Array<RttrStandingEntry>}
     * @memberof RttrStandingsResponse
     */
    standings: Array<RttrStandingEntry>;
    /**
     * 
     * @type {number}
     * @memberof RttrStandingsResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof RttrStandingsResponse
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof RttrStandingsResponse
     */
    offset: number;
}

/**
 * Check if a given object implements the RttrStandingsResponse interface.
 */
export function instanceOfRttrStandingsResponse(value: object): value is RttrStandingsResponse {
    if (!('challengeId' in value) || value['challengeId'] === undefined) return false;
    if (!('standings' in value) || value['standings'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('offset' in value) || value['offset'] === undefined) return false;
    return true;
}

export function RttrStandingsResponseFromJSON(json: any): RttrStandingsResponse {
    return RttrStandingsResponseFromJSONTyped(json, false);
}

export function RttrStandingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrStandingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'challengeId': json['challengeId'],
        'standings': ((json['standings'] as Array<any>).map(RttrStandingEntryFromJSON)),
        'total': json['total'],
        'limit': json['limit'],
        'offset': json['offset'],
    };
}

export function RttrStandingsResponseToJSON(json: any): RttrStandingsResponse {
    return RttrStandingsResponseToJSONTyped(json, false);
}

export function RttrStandingsResponseToJSONTyped(value?: RttrStandingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challengeId': value['challengeId'],
        'standings': ((value['standings'] as Array<any>).map(RttrStandingEntryToJSON)),
        'total': value['total'],
        'limit': value['limit'],
        'offset': value['offset'],
    };
}

